<template>
  <div class="wh100">
    <LayoutLeftRight :span="[8, 16]" :gutter="15">
      <template slot="left">
        <MyPanel class="leftP">
          <div class="wh100">
            <el-row>
              <el-col :span="8">断面名称:</el-col>
              <el-col :span="16">{{ stationName }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="8">控制单元:</el-col>
              <el-col :span="16">{{ ControlUnitName }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="8">河流:</el-col>
              <el-col :span="16">{{ WaterName }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="8">类型：</el-col>
              <el-col :span="16">{{ StationType }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="8">所属地市：</el-col>
              <el-col :span="16">{{ CityName }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="8">所属区县：</el-col>
              <el-col :span="16">{{ CountyName }}</el-col>
            </el-row>
          </div>
        </MyPanel>
      </template>
      <template slot="right">
        <div class="wh100">
          <div class="selChannel">
            <el-select
              v-model="channelMap"
              placeholder="请选择"
              @change="getChartData"
            >
              <el-option
                v-for="item in channels"
                :key="item.ChannelMap"
                :label="item.ChannelName"
                :value="item.ChannelMap"
              >
              </el-option>
            </el-select>
          </div>
          <MyPanel class="rightP" :title="rightTitle">
            <MyChart
              :defOptions="chart.options"
              :change="chart.myChange"
              ref="mychart"
            ></MyChart>
          </MyPanel>
        </div>
      </template>
    </LayoutLeftRight>
  </div>
</template>

<script>
import LayoutLeftRight from "../../../../components/layout/LayoutLeftRight";
import MyChart from "../../../../components/EChart";
import MyPanel from "../../../../components/Pannel/Pannel";
export default {
  components: {
    LayoutLeftRight,
    MyChart,
    MyPanel,
  },
  props: {
    stationName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      leftTitle: "断面属性",
      rightTitle: "水质变化趋势",
      ControlUnitName: "",
      StationType: "",
      WaterName: "",
      CityName: "",
      CountyName: "",
      channels: [],
      channelMap: "",
      chart: {
        myChange: 1,
        options: {
          title: {
            text: "",
          },
          grid: {
            left: 40,
            right: 40,
            bottom: 25,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: [],
          },
          toolbox: {
            show: true,
            feature: {
              saveAsImage: {
                name: "单站点多指标统计",
              },
            },
          },
          yAxis: [
            {
              name: "指标值",
              type: "value",
            },
          ],
          tooltip: {
            valueSuffix: "", // 提示信息所带单位
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          legend: {
            show: true,
            selected: {},
            data: [],
          },
          series: [],
          animationEasing: "elasticOut",
          animationDelayUpdate: function (idx) {
            return idx * 5;
          },
        },
      },
    };
  },
  methods: {
    loadData() {
      debugger;
      this.getChartData();
      this.getStationData();
    },
    GetChannelData() {
      let that = this;
      that.$api.get(
        "/Map/GetShowChannelInfo",
        null,
        function (res) {
          if (res.code == 200) {
            that.channels = res.data.filter((e) => {
              return e.ChannelMap != "WaterLevel";
            });
            that.channelMap = that.channels[0].ChannelMap;
          }
        },
        function () {},
        true
      );
    },
    getStationData() {
      let that = this;
      that.$api.get(
        "/Station/GetStationByName",
        {
          stationName: that.stationName,
        },
        function (res) {
          if (res.code == 200) {
            if (res.data.length > 0) {
              that.ControlUnitName = res.data[0].ControlUnitName;
              that.StationType = res.data[0].StationType;
              that.WaterName = res.data[0].WaterName;
              that.CityName = res.data[0].CityName;
              that.CountyName = res.data[0].CountyName;
            }
          }
        },
        function () {},
        true
      );
    },
    getChartData() {
      let that = this;
      that.$api.get(
        "/DataAnalysis/MoreAnalysis",
        {
          dataType: "year",
          stations: that.stationName,
          beginTime: "2000",
          endTime: "2222",
          channel: that.channelMap,
        },
        function (res) {
          if (res.code == 200) {
            that.chart.options.legend.data = res.data.legendData;
            that.chart.options.xAxis.data = res.data.xData;
            let series = [];
            for (let i = 0; i < res.data.legendData.length; i++) {
              series.push({
                name: res.data.legendData[i],
                type: "line",
                smooth: true,
                data: res.data.seriesData[i],
              });
            }
            that.chart.options.series = series;
            that.chart.myChange++;
          }
        },
        function () {},
        true
      );
    },
  },

  mounted() {
    this.GetChannelData();
  },
  watch: {},
};
</script>
<style lang="less" scoped>
.el-row {
  padding: 10px 0px;
}
.left,
.right {
  border: dotted 1px violet;
  padding: 10px;
}
.selChannel {
  position: absolute;
  margin-top: 20px;
  right: 20px;
}
/deep/ .leftP {
  background: rgba(1, 174, 222, 0.13);
  padding: 1rem;
  border: unset;
  .content-container {
    background: rgba(1, 174, 222, 0.1);
    border: 1px dashed rgba(1, 174, 222, 0.3);
    line-height: 1.5rem;
    padding: 1rem;
  }
}
/deep/ .rightP {
  background: rgba(1, 174, 222, 0.13);
  padding: 1rem;
  border: unset;
  .content-container {
    background: rgba(255, 255, 255, 0.6);
    border: 1px dashed rgba(1, 174, 222, 0.3);
    line-height: 1.5rem;
    padding: 1rem;
  }
}
/deep/ .el-select .el-input.is-focus .el-input__inner {
  background: unset;
}
/deep/ .el-input__inner {
  background: unset;
  color: #00e4ff;
}
/deep/ .el-select-dropdown {
  background: rgba(1, 174, 222, 0.13);
}
</style>